export default __webpack_public_path__ + "static/media/8d4678ab-58c8-4275-910e-239d6b278a8e.497e2fc7.jpg";